(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9378],{

/***/ 11229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print/quote",
      function () {
        return __webpack_require__(83412);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ quote; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/customizing/print/Print.styles.js
var Print_styles = __webpack_require__(32252);
// EXTERNAL MODULE: ./components/filterList/FilterList.js + 3 modules
var FilterList = __webpack_require__(85830);
// EXTERNAL MODULE: ./components/customizing/print/printCart/PrintCart.js + 1 modules
var PrintCart = __webpack_require__(34077);
// EXTERNAL MODULE: ./hook/app/useUserInfo.js
var useUserInfo = __webpack_require__(15259);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/smallPackaging.js
var smallPackaging = __webpack_require__(85134);
;// CONCATENATED MODULE: ./hook/customizing/print/usePrintProductListQuery.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintProductListQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.PRODUCTS */.U.CUSTOMIZING.PRINT.PRODUCTS
        ],
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, body, res, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        body = {
                            modes: "ProductsListSet"
                        };
                        _ctx.next = 4;
                        return (0,smallPackaging/* smallPackagingAPI */.t)(body);
                    case 4:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.rows.data);
                    case 8:
                        throw new Error(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uC0C1\uD488 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
};
var usePrintCartItemsQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ],
        queryFn: function() {
            var items = JSON.parse(sessionStorage.getItem("printCart") || "[]");
            return items;
        },
        enabled: "object" !== "undefined"
    });
};

// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/customizing/print/PrintInquiryModal.js
var PrintInquiryModal = __webpack_require__(87607);
// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./components/customizing/print/PrintDesignService.js
var PrintDesignService = __webpack_require__(52658);
// EXTERNAL MODULE: ./components/customizing/print/printTab/PrintTab.jsx
var PrintTab = __webpack_require__(48071);
;// CONCATENATED MODULE: ./pages/customizing/print/quote/index.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function quote_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function quote_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                quote_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                quote_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















var QuotePage = function() {
    var ref7;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var listRef = (0,react.useRef)(null);
    var cartRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)({}), inquiryInputs = ref1[0], setInquiryInputs = ref1[1];
    var ref2 = (0,react.useState)(false), openInquiryModal = ref2[0], setOpenInquiryModal = ref2[1];
    var ref3 = (0,react.useState)(false), openInquiryComplete = ref3[0], setOpenInquiryComplete = ref3[1];
    var ref4 = (0,useUserInfo/* default */.Z)(), userInfo = ref4.userInfo, getUserInfo = ref4.getUserInfo;
    var ref5 = usePrintProductListQuery(), productList = ref5.data;
    var ref6 = usePrintCartItemsQuery(), tmp = ref6.data, printCartItems = tmp === void 0 ? [] : tmp;
    var userCompany = (0,react.useMemo)(function() {
        var ref;
        return (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Company) === null || ref === void 0 ? void 0 : ref.Data) || null;
    }, [
        userInfo
    ]);
    // 카트 담기
    var addPrintCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
            router.push("/login");
            return;
        }
        var currentCart = queryClient.getQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ]) || [];
        if (currentCart.find(function(el) {
            return el.pcode === product.pcode;
        })) {
            (0,common_alert/* failAlert */.qh)("\uC774\uBBF8 \uB2F4\uAE34 \uC0C1\uD488\uC785\uB2C8\uB2E4.");
            return;
        }
        var newCart = [
            _objectSpread({}, product, {
                cnt: 1
            })
        ].concat(_toConsumableArray(currentCart));
        // 장바구니 업데이트
        queryClient.setQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ], newCart);
        sessionStorage.setItem("printCart", JSON.stringify(newCart));
        (0,common_alert/* successAlert */.Cq)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4.");
        // 부드러운 스크롤 이동
        window.scrollTo({
            behavior: "smooth",
            left: 0,
            top: cartRef.current.offsetTop
        });
    };
    // 카트 담긴 상태
    var inCart = function(product) {
        return printCartItems.some(function(el) {
            return el.pcode === product.pcode;
        });
    };
    var onClickInquiry = function() {
        var _ref = quote_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenInquiryModal(function(prev) {
                            return !prev;
                        });
                        setInquiryInputs({});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInquiry = function(e, id) {
        if (id.includes("file")) {
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.files[0])));
            return;
        }
        if (id === "policy") {
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.checked)));
            return;
        }
        setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.value)));
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var submitInquiry = function() {
        var _ref = quote_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.name || !inquiryInputs.tel || !inquiryInputs.cnt || !inquiryInputs.usages || !inquiryInputs.email || !inquiryInputs.content)) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD56D\uBAA9\uC744 \uC804\uBD80 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.policy) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 9:
                        isLoading();
                        body = _objectSpread({
                            modes: "InquirySet",
                            division: "F",
                            pcode: "P000001"
                        }, inquiryInputs);
                        _ctx.next = 13;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 13:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uBB38\uC758\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            isLoaded();
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getUserInfo();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                parent: "\uD648",
                sub: "\uC18C\uB7C9\uC778\uC1C4",
                subTitle: "\uC0C1\uD488 \u2022 \uACAC\uC801",
                pageTitle: SeoMeta/* SeoMeta.smallPrintServiceQuote.title */.e.smallPrintServiceQuote.title,
                pageDesc: SeoMeta/* SeoMeta.smallPrintServiceQuote.description */.e.smallPrintServiceQuote.description,
                pageKeyword: SeoMeta/* SeoMeta.smallPrintServiceQuote.keywords */.e.smallPrintServiceQuote.keywords,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintTab/* PrintTab */.d, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        ref: listRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* NormalTitle */.XG, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\uC0C1\uD488 \uBC0F \uACAC\uC801"
                                    }),
                                    "\uC744 \uD55C \uBC88\uC5D0 \uC9C4\uD589\uD558\uC138\uC694."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList/* default */.Z, {
                                productList: productList,
                                inCart: inCart,
                                addCart: addPrintCart
                            })
                        ]
                    }),
                    (userInfo === null || userInfo === void 0 ? void 0 : (ref7 = userInfo.Member) === null || ref7 === void 0 ? void 0 : ref7.ukey) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        ref: cartRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintCart/* default */.Z, {
                            userInfo: userInfo,
                            userCompany: userCompany,
                            moveToList: function() {
                                var ref;
                                return (ref = listRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                                    behavior: "smooth"
                                });
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container py-50 mt-30 mb-30",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/login",
                                        children: "\uB85C\uADF8\uC778"
                                    }),
                                    " \uD6C4 \uC774\uC6A9\uAC00\uB2A5\uD55C \uC11C\uBE44\uC2A4\uC785\uB2C8\uB2E4."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintDesignService/* PrintDesignService */.$, {})
                ]
            }),
            openInquiryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintInquiryModal/* default */.Z, {
                onClickInquiry: onClickInquiry,
                inquiryInputs: inquiryInputs,
                onChangeInquiry: onChangeInquiry,
                submitInquiry: submitInquiry
            }),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            })
        ]
    });
};
/* harmony default export */ var quote = (QuotePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,2511,4027,783,4948,1111,5830,4238,9774,2888,179], function() { return __webpack_exec__(11229); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);